import React, { Component } from "react";
import { Tabs, Tab, TabPanel, TabList } from "react-web-tabs";
import "react-web-tabs/dist/react-web-tabs.css";
import "../components/Navigation.scss";
import Titlebar from "../shared/component/Titlebar";
import UserGroupRestriction from "../components/UserGroupRestriction";
import SiteandRegion from "../components/SiteandRegion";
import CreateForm from "./CreateForm";
import FormBuilderService from "../services/form-builder.service";
import { withStyles } from "@material-ui/styles";

const styles = {
  disabledTabs: {
    "& > .rwt__tab": {
      pointerEvents: "none",
      opacity: 0.5,
      cursor: "not-allowed",
    },
  },
};

class FormTabs extends Component {
  constructor() {
    super();
    this.state = {
      formTabName: "new-form",
      isLoading: true,
      isConditionalForm: false,
      isConditionalLoading: false,
      universalHierarchyData: {},
      isUniversalHierarchyChanged: false,
    };
    this.formBuilderService = new FormBuilderService();
    this.newRef = React.createRef();
  }

  handleSelect = (event) => {
    this.setState({
      formTabName: event,
    });
  };

  setLoading = (loading) => {
    this.setState({ isLoading: loading });
  };

  setIsConditionalForm = (flag) => {
    this.setState({ isConditionalForm: flag });
  };

  setIsConditionalLoading = (flag) => {
    this.setState({ isConditionalLoading: flag });
  };

  setUniversalHierarchyData = (data) => {
    this.setState({ universalHierarchyData: data });
  };

  setIsUniversalHierarchyChanged = (flag) => {
    this.setState({ isUniversalHierarchyChanged: flag });
  };

  render() {
    const { classes } = this.props;
    return (
      <Tabs
        defaultTab={this.state.formTabName}
        horizontal="true"
        style={{ background: "#fcfcfc" }}
        onChange={($event) => this.handleSelect($event)}
      >
        <TabList className={this.state.isLoading ? classes.disabledTabs : ""}>
          <Titlebar
            title={
              this.props.copyForm
                ? "Copy Form"
                : this.props.updateForm
                ? "Edit Form Meta Data"
                : "Create New Form"
            }
          />
          <Tab tabFor="new-form">FORM DETAIL</Tab>
          <Tab tabFor="user-group">USER GROUP</Tab>
          <Tab tabFor="site-region">SITE &amp; REGION</Tab>
        </TabList>

        <TabPanel tabId="new-form" style={{ width: "100%" }}>
          <CreateForm
            {...this.props}
            ref={this.newRef}
            setLoading={this.setLoading}
            isConditionalForm={this.state.isConditionalForm}
            setIsConditionalForm={this.setIsConditionalForm}
            isConditionalLoading={this.state.isConditionalLoading}
            setIsConditionalLoading={this.setIsConditionalLoading}
            universalHierarchyData={this.state.universalHierarchyData}
            setUniversalHierarchyData={this.setUniversalHierarchyData}
            isUniversalHierarchyChanged={this.state.isUniversalHierarchyChanged}
            setIsUniversalHierarchyChanged={this.setIsUniversalHierarchyChanged}
          />
        </TabPanel>

        <TabPanel tabId="user-group" style={{ width: "100%" }}>
          <UserGroupRestriction
            {...this.props}
            validate={this.newRef.current}
            isConditionalForm={this.state.isConditionalForm}
            isConditionalLoading={this.state.isConditionalLoading}
            universalHierarchyData={this.state.universalHierarchyData}
            isUniversalHierarchyChanged={this.state.isUniversalHierarchyChanged}
          />
        </TabPanel>

        <TabPanel tabId="site-region" style={{ width: "100%" }}>
          <SiteandRegion
            {...this.props}
            validate={this.newRef.current}
            isConditionalForm={this.state.isConditionalForm}
            isConditionalLoading={this.state.isConditionalLoading}
            universalHierarchyData={this.state.universalHierarchyData}
            isUniversalHierarchyChanged={this.state.isUniversalHierarchyChanged}
          />
        </TabPanel>
      </Tabs>
    );
  }
}

export default withStyles(styles, { withTheme: true })(FormTabs);
